import { notification } from 'antd'
import type { NotificationPlacement } from 'antd/es/notification/interface'

interface notiProps {
  placement?: NotificationPlacement
  description?: string
  message?: string,
  duration?:number
}

export const notifyError = (props: notiProps) => {
  const { placement = 'topRight', description, message, duration } = props
  return notification['error']({
    message: message,
    description: description,
    placement,
    duration
  })
}

export const notifySuccess = (props: notiProps) => {
  const { placement = 'topRight', description, message } = props
  return notification['success']({
    message: message,
    description: description,
    placement
  })
}

export const notifyInfo = (props: notiProps) => {
  const { placement = 'topRight', description, message } = props
  return notification['info']({
    message: message,
    description: description,
    placement
  })
}

export const notifyWarning = (props: notiProps) => {
  const { placement = 'topRight', description, message } = props
  return notification['warning']({
    message: message,
    description: description,
    placement
  })
}
